// extracted by mini-css-extract-plugin
module.exports = {"fixSlide":"fixSlide-3KfAVD5A","fixSlideBox":"fixSlideBox-1pvip2Ja"};